import { Navigate } from "react-router-dom";
import { useAuth } from '@/context/AuthContext';
import { routes } from "@/config/routes";
import { AccountType, UserRole } from "@/types";
import { landingRouteForUser } from "@/utils/landingRoute";
import { useMemo } from "react";
// Protected route component
interface ProtectedRouteProps {
    children?: React.ReactNode;
    requiredRoles?: string[];
    allowedAccountTypes?: AccountType[];
  }

  const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    // eslint-disable-next-line react/prop-types
    children,
    // eslint-disable-next-line react/prop-types
    requiredRoles = [],
    // eslint-disable-next-line react/prop-types
    allowedAccountTypes = []
  }) => {
    const { auth } = useAuth();
    const { isAuthenticated, user } = auth;
    // Shared with the account switchers, so a switched-into session and a redirected
    // route can never disagree about where a role belongs.
    const rootRoute = useMemo(
        () => landingRouteForUser({ role: user?.role, accountType: user?.accountType }),
        [user]
    );

    // Add debug logging
    // console.log('ProtectedRoute - Auth state:', { isAuthenticated, userRole: user?.role });
    // console.log('ProtectedRoute - Required roles:', requiredRoles);

    // Show loading state if auth is still initializing
    // if (loading) {
    //   return <div className="flex items-center justify-center h-screen">Loading...</div>;
    // }

    // If not authenticated, redirect to login
    if (!isAuthenticated) {
      if (requiredRoles.includes(UserRole.END_CUSTOMER)) {
        return <Navigate to={routes.ec.login} replace />;
      }
      return <Navigate to={routes.auth.login} replace />;
    }

    // If account types are specified and user doesn't have allowed account type, redirect to root
    if (allowedAccountTypes.length > 0 && user && !allowedAccountTypes.includes(user.accountType as AccountType)) {
      console.log('Account type check failed - user does not have allowed account type');
      return <Navigate to={rootRoute} replace />;
    }

    // If roles are specified and user doesn't have required role, redirect to dashboard
    if (requiredRoles.length > 0 && user && !requiredRoles.includes(user.role)) {
      console.log('Role check failed - user does not have required role');
      return <Navigate to={rootRoute} replace />;
    }

    if (!children) {
      return <Navigate to={rootRoute} replace />;
    }

    return <>{children}</>;
  };

  export default ProtectedRoute;
